import { DirectionalIconProps } from "../../types/styles";

const TriangleIcon = ({
    id,
    className,
    size = 10,
    customColor,
    direction = "up",
    ...rest
}: DirectionalIconProps) => {
    const rotationTailwindClasses = {
        up: "rotate-0",
        down: "rotate-180",
        right: "rotate-90",
        left: "-rotate-90",
    };

    const color = customColor ?? "var(--color-neutral-600)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : `icon-triangle-${direction}`}
            className={`${rotationTailwindClasses[direction]}${className ? ` ${className}` : ""}`}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill={color}
        >
            <polygon points="12,7 4,16 20,16" />
        </svg>
    );
};

export default TriangleIcon;
